import React from 'react'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { $DCprimaryColor, PixelIcon, PixelTooltip, colors } from 'pixel-base'
import styled from 'styled-components'

const StepBar = (props) => {
  const { Steps, size, activeStep } = props
  return (
    <Main size={size}>
      {Steps.map((step, index) => {
        if (index < Steps.indexOf(Steps.find((s) => s.title === activeStep))) {
          step.active = true
        }
        return (
          <React.Fragment key={index}>
            <FirstIcon className={step.active ? 'active' : ''} size={size}>
              <PixelTooltip tooltipText="testing">
                <PixelIcon
                  fontSize={size === 'sm' ? '12px' : '15px'}
                  color="white"
                  icon={step.active ? faCheck : step.icon}
                />
              </PixelTooltip>
            </FirstIcon>
            {index !== Steps.length - 1 && (
              <Progress className={step.active ? 'active' : ''}></Progress>
            )}
          </React.Fragment>
        )
      })}
    </Main>
  )
}
const Main = styled.div<{ size?: string }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;
  padding: ${(props) => (props.size === 'sm' ? '5px' : '10px')};
  background: rgba(0, 0, 0, 0.05);
  border-radius: 50px;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
  width: 100%;
`
const FirstIcon = styled.div<{ size?: string }>`
  border-radius: 50%;
  background: ${colors.grayTextMedium};
  color: ${colors.white};
  width: ${(props) => (props.size === 'sm' ? '25px' : '30px')};
  height: ${(props) => (props.size === 'sm' ? '25px' : '30px')};
  padding: ${(props) => (props.size === 'sm' ? '10px' : '7px')};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  &.active {
    background: ${$DCprimaryColor};
    transition: 0.5s cubic-bezier(0.97, 0.48, 0.06, 0.7);
  }
`
const Progress = styled.div`
  width: 100%;
  height: 5px;
  background: rgb(224 224 224);
  display: block;
  background: ${colors.grayTextMedium};
  &.active {
    background: ${$DCprimaryColor};
    transition: 0.5s cubic-bezier(0.97, 0.48, 0.06, 0.7);
  }
`

export default StepBar
